// @ts-nocheck
import {Column} from 'react-table'
import {PlanFeaturesActionsCell} from './PlanFeaturesActionsCell'
import {PlanFeaturesCustomHeader} from './PlanFeaturesCustomHeader'
import {PlanFeatures} from '../../core/_models'

const PlanFeaturesColumns: ReadonlyArray<Column<PlanFeatures>> = [
  {
    Header: (props) => (
      <PlanFeaturesCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    accessor: 'serialNo',
  },
 
  
  {
    Header: (props) => (
      <PlanFeaturesCustomHeader tableProps={props} title='name' className='min-w-125px' />
    ),
    accessor: 'name',
  },
 
  {
    Header: (props) => (
      <PlanFeaturesCustomHeader
        tableProps={props}
        title='Actions'
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <PlanFeaturesActionsCell planfeatures={props.data[props.row.index]} />,
  },
]

export {PlanFeaturesColumns}
